import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SFGridContainer, SFGridItem } from "../../grid";
import { SFStack } from "../../grid";
import SFGenericSearch from "../../typeahead/genericSearch";
import SFTypography from "../../typography";
import SFCheckbox from "../../checkbox";
import SFShowMoreBtn from "../../link/showMoreBtn";
import getStyled from "../../../hooks/getStyled";
import { SHOW_MORE_COUNT } from "./filterGroup";

const { styled } = getStyled();

export const TextFilterGroupOption = ({
  colName,
  label,
  value,
  count = 0,
  currentSelection,
  updateCurrentSelection,
  disabled = false,
  labelFormatter,
}) => {
  const isChecked = currentSelection[colName].includes(value);
  const handleChange = (event) => {
    updateCurrentSelection(colName, value);
  };
  const optionLabel = label
    ? label
    : labelFormatter
      ? labelFormatter(value)
      : String(value);

  return (
    <SFCheckbox
      checked={isChecked}
      onChange={handleChange}
      disabled={disabled}
      label={
        <SFStack direction="row" alignItems="flex-end" spacing={0.5}>
          {typeof optionLabel === "string" ? (
            <SFTypography variant="tableList" className="max-2-lines">
              {optionLabel}
            </SFTypography>
          ) : (
            optionLabel
          )}
          <SFTypography variant="tableList">{`(${count})`}</SFTypography>
        </SFStack>
      }
    />
  );
};

const SFGenericSearchStyled = styled(SFGenericSearch)(({ theme }) => ({
  "& .MuiFilledInput-root": {
    backgroundColor: theme.palette.white.main,
    marginBottom: theme.spacing(1.25),
  },
}));

const TextFilterGroup = ({
  colName,
  values = [],
  counts = [],
  currentSelection,
  updateCurrentSelection,
  defaultSelectedValues = [],
  search,
  disableAll = false,
  labelFormatter,
  comparator,
  hideOption = () => false,
}) => {
  const { t } = useTranslation();

  const [visibleCount, setVisibleCount] = useState(SHOW_MORE_COUNT);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + SHOW_MORE_COUNT);
  };

  const sortedValues = comparator ? [...values].sort(comparator) : values;

  return (
    <>
      {search && (
        <SFGenericSearchStyled
          hasSearchIcon
          placeholder={t("components.fullSearchDialog.searchPlaceholder")}
          size="small"
          multiple
          source={sortedValues.map((value) => ({ value }))}
          selectedValues={currentSelection[colName]}
          onSelect={(option) => updateCurrentSelection(colName, option.value)}
        />
      )}
      <SFGridContainer direction="column" spacing={0}>
        {sortedValues.slice(0, visibleCount).map((value, index) => {
          if (hideOption(value)) {
            return null;
          }
          return (
            <SFGridItem key={index}>
              <TextFilterGroupOption
                colName={colName}
                value={value}
                count={counts.find((x) => x.value === value)?.count}
                currentSelection={currentSelection}
                updateCurrentSelection={updateCurrentSelection}
                disabled={defaultSelectedValues.includes(value) || disableAll}
                labelFormatter={labelFormatter}
              />
            </SFGridItem>
          );
        })}
        {visibleCount < sortedValues.length && (
          <SFGridItem>
            <SFShowMoreBtn onClick={handleShowMore} />
          </SFGridItem>
        )}
      </SFGridContainer>
    </>
  );
};

export default TextFilterGroup;
